import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c99fb6f4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "arcode-workspace-logo",
  class: "logo",
  version: "1.0",
  xmlns: "http://www.w3.org/2000/svg",
  width: "2667.000000pt",
  height: "2667.000000pt",
  viewBox: "0 0 2667.000000 2667.000000",
  preserveAspectRatio: "xMidYMid meet"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("g", { transform: "translate(0.000000,2667.000000) scale(0.100000,-0.100000)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "M12400 25819 c-271 -7 -310 -10 -650 -55 -1410 -183 -2743 -587\n-3990 -1208 -610 -304 -1124 -613 -1686 -1012 -1400 -994 -2607 -2298 -3484\n-3764 -961 -1605 -1550 -3389 -1732 -5245 -10 -97 -13 -410 -13 -1220 0 -1209\n-5 -1090 70 -1650 298 -2208 1176 -4300 2535 -6040 508 -650 1105 -1274 1740\n-1819 1725 -1482 3860 -2476 6110 -2845 221 -36 578 -87 710 -101 138 -14\n1480 -32 1995 -27 448 5 540 11 940 63 904 116 1826 341 2685 654 1271 463\n2496 1152 3538 1988 982 789 1849 1726 2544 2752 1033 1524 1727 3282 2012\n5095 34 217 82 597 98 780 18 209 18 2113 0 2330 -42 502 -163 1218 -307 1813\n-475 1961 -1480 3879 -2799 5342 -611 677 -1144 1168 -1836 1692 -1487 1125\n-3279 1927 -5110 2287 -408 80 -1014 165 -1360 191 -152 11 -1596 11 -2010 -1z\nm1780 -1949 c1740 -157 3246 -650 4705 -1538 912 -556 1754 -1279 2517 -2162\n359 -416 796 -1039 1095 -1560 418 -728 737 -1471 973 -2260 222 -744 374\n-1582 421 -2325 16 -251 17 -1158 1 -1385 -125 -1794 -678 -3479 -1638 -4993\n-837 -1318 -1981 -2454 -3304 -3279 -434 -271 -1001 -568 -1450 -758 -1000\n-425 -2040 -693 -3105 -799 -417 -42 -502 -46 -1050 -46 -662 1 -950 20 -1550\n106 -1650 236 -3292 905 -4665 1902 -1376 999 -2481 2302 -3241 3819 -459 917\n-772 1856 -953 2858 -108 600 -152 1052 -162 1655 -15 866 44 1530 206 2335\n209 1037 597 2088 1113 3015 439 789 998 1549 1596 2170 1023 1060 2138 1836\n3468 2414 1079 468 2307 765 3478 841 94 6 190 12 215 14 25 2 284 2 575 0\n432 -2 572 -7 755 -24z" }),
  /*#__PURE__*/_createElementVNode("path", { d: "M13330 18504 c-19 -2 -102 -11 -185 -20 -457 -47 -882 -151 -1245\n-304 -345 -145 -725 -371 -980 -583 -231 -192 -487 -481 -619 -700 -205 -339\n-325 -754 -333 -1152 l-3 -140 1173 -3 c937 -2 1172 0 1172 11 0 52 33 276 50\n337 45 163 150 322 313 477 151 143 369 232 639 262 120 13 521 14 643 1 352\n-37 708 -177 941 -369 174 -144 328 -428 380 -699 13 -68 18 -171 21 -483 l5\n-396 -948 -6 c-993 -7 -1202 -14 -1544 -57 -675 -84 -1182 -223 -1619 -445\n-359 -182 -787 -519 -994 -782 -376 -477 -566 -1102 -544 -1788 15 -461 108\n-796 339 -1220 188 -345 340 -525 594 -705 457 -325 1114 -600 1658 -695 226\n-39 902 -45 1101 -10 310 55 804 222 1150 390 181 88 241 127 410 271 181 154\n374 304 390 304 8 0 16 -19 20 -52 4 -29 16 -91 27 -138 11 -47 26 -121 34\n-165 15 -89 105 -379 135 -437 l19 -38 1227 0 1226 0 -6 74 c-3 44 -18 108\n-37 162 -76 213 -175 586 -230 869 l-32 160 -9 2035 c-5 1119 -13 2285 -18\n2590 l-10 555 -29 145 c-46 220 -77 336 -152 560 -131 391 -275 667 -485 928\n-238 295 -614 583 -1010 773 -485 232 -1089 409 -1610 470 -87 10 -955 21\n-1025 13z m1820 -5961 l0 -787 -149 -150 c-82 -83 -174 -180 -203 -216 -81\n-97 -149 -146 -340 -247 -247 -130 -505 -238 -708 -295 -140 -40 -726 -35\n-948 7 -99 19 -273 79 -352 122 -179 96 -325 250 -419 439 -80 164 -101 282\n-101 584 0 245 24 365 112 550 36 76 54 99 167 211 180 179 306 280 416 333\n203 99 424 174 595 203 117 19 528 29 1343 31 l587 2 0 -787z" })
], -1))
const _hoisted_3 = [
  _hoisted_2
]

import { onMounted } from 'vue';
import anime from 'animejs/lib/anime.es.js';


export default /*#__PURE__*/_defineComponent({
  __name: 'AnimatedLogo',
  setup(__props) {

onMounted(() => {
  // Animations
  anime({
    targets: '#arcode-workspace-logo path',
    keyframes: [
      { strokeDashoffset: [anime.setDashoffset, 0], duration: 5000, delay: 4000 },
      { filter: 'invert(1)', delay: 8000, duration: 4000 },
      { filter: 'invert(0.5)', delay: 5000, duration: 1000 },
      
    ],
    easing: 'easeInOutSine',
    // duration: 9000,
    // eslint-disable-next-line
    delay: function(el, i) { return  3000 },
    direction: 'alternate',
    loop: true
  });

  anime({
    targets: '#arcode-workspace-logo path',
    rotateY: {
      value: '360deg',
      duration: 3600,
      easing: 'easeInOutBounce'
    },
    easing: 'linear',
    // eslint-disable-next-line
    delay: function(el, i) { return  6000 },
    loop: true
  })
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
}

})